export const tiposEvento = [
  // {
  //   codigo: "110001",
  //   descricao: "Cancelamento de Evento",
  //   campos: [],
  // },
  {
    codigo: "112120",
    descricao: "Importação em ALC/ZFM não convertida em isenção",
    campos: ["chaveAcesso", "estNfEntradaId", "itens"],
  },
  {
    codigo: "112130",
    descricao:
      "Perecimento, perda, roubo ou furto durante o transporte contratado pelo fornecedor",
    campos: ["chaveAcesso", "estNfEntradaId", "itens"],
  },
  {
    codigo: "112140",
    descricao: "Fornecimento não realizado com pagamento antecipado",
    grupoDocumento: "NFE_ENTRADA",
    campos: ["chaveAcesso", "estNfEntradaId", "itens"],
  },
  {
    codigo: "112150",
    descricao: "Atualização da Data de Previsão de Entrega",
    campos: ["chaveAcesso", "fatNfSaidaId", "dataPrevistaEntrega"],
  },
  // {
  //   codigo: "211110",//fazer
  //   descricao: "Solicitação de Apropriação de crédito presumido",
  //   campos: [],
  // },
  {
    codigo: "211124",
    descricao:
      "Perecimento, perda, roubo ou furto durante o transporte contratado pelo adquirente",
    campos: ["chaveAcesso", "estNfEntradaId", "itens"],
  },
  {
    codigo: "211128",
    descricao: "Aceite de débito na apuração por emissão de nota de crédito",
    campos: ["chaveAcesso", "estNfEntradaId", "aceiteCreditoDebitoNota"],
  },
  {
    codigo: "211130",
    descricao: "Imobilização de Item",
    campos: ["chaveAcesso", "estNfEntradaId", "itens"],
  },
  {
    codigo: "211140",
    descricao: "Solicitação de Apropriação de Crédito de Combustível",
    campos: ["chaveAcesso", "estNfEntradaId", "itens"],
  },
  {
    codigo: "211150",
    descricao:
      "Solicitação de Apropriação de Crédito para bens e serviços que dependem de atividade do adquirente",
    campos: ["chaveAcesso", "estNfEntradaId", "itens"],
  },
  {
    codigo: "212110",
    descricao:
      "Manifestação sobre Pedido de Transferência de Crédito de IBS em Operação de Sucessão",
    campos: ["chaveAcesso", "estNfEntradaId", "aceiteCreditoDebitoNota"],
  },
  {
    codigo: "212120",
    descricao:
      "Manifestação sobre Pedido de Transferência de Crédito de CBS em Operação de Sucessão",
    campos: ["chaveAcesso", "estNfEntradaId", "aceiteCreditoDebitoNota"],
  },
];
